import { render, staticRenderFns } from "./dialog-shenpi.vue?vue&type=template&id=3f79b23c&scoped=true&"
import script from "./dialog-shenpi.vue?vue&type=script&lang=js&"
export * from "./dialog-shenpi.vue?vue&type=script&lang=js&"
import style0 from "./dialog-shenpi.vue?vue&type=style&index=0&id=3f79b23c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f79b23c",
  null
  
)

export default component.exports